import { CustomAppsAdminPage } from '@jarvis/platform-ui';
import { useMemo } from 'react';
import {
  CLIENT_PORTAL_APP_ROLES,
  createClientPortalCustomAppsAdminApi
} from '../../../api/clientPortalCustomApps';

export function ClientPortalCustomAppsAdminPage() {
  const api = useMemo(() => createClientPortalCustomAppsAdminApi(), []);

  return (
    <CustomAppsAdminPage
      api={api}
      availableRoles={CLIENT_PORTAL_APP_ROLES}
      title="Client Portal Custom Apps"
      subtitle="Custom apps for the client portal site. Active apps appear in the portal's My Apps and sidebar immediately, and open the link in a new tab. Visibility can be limited by SPR role or client Entra group."
      refreshLocalMyApps={false}
    />
  );
}
